// extracted by mini-css-extract-plugin
export default {"heading":"Balance_heading__rvkU9","contrast":"Balance_contrast__TLG+v"};